/* eslint-disable react/jsx-no-bind */
import React, { useContext, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AlertsContext } from '../shared/alerts/Alerts.context';
import LoggingService from '../shared/Logging.api';
import adminFormStyles from '../shared/styles/adminForm.styles';
import TasksApi from '../tasks/Tasks.api';
import { targetingToAPI } from '../tasks/TaskTargeting.utils';
import AlertForm from './forms/AlertForm';
import AlertScheduleModal from './forms/AlertScheduleModal';
import AlertsService from './Alerts.service';

const styles = {
  page: adminFormStyles.page,
  content: adminFormStyles.content,
};

export default function AlertFormPage() {
  const navigate = useNavigate();
  const { showAlert } = useContext(AlertsContext);
  const [alertPendingSchedule, setAlertPendingSchedule] = useState(null);
  const [isScheduling, setIsScheduling] = useState(false);
  const [pendingReach, setPendingReach] = useState(null);
  const [isPendingReachLoading, setIsPendingReachLoading] = useState(false);

  // On opening the review, calculate the reach shown in the modal - including
  // for an untargeted alert, so the admin always sees real numbers.
  useEffect(() => {
    if (!alertPendingSchedule) {
      return undefined;
    }

    let cancelled = false;
    setIsPendingReachLoading(true);

    TasksApi.getReach(targetingToAPI(alertPendingSchedule.targeting))
      .then((reach) => {
        if (!cancelled) setPendingReach(reach);
      })
      .catch((error) => {
        LoggingService.error('Failed to calculate alert reach', error);
      })
      .finally(() => {
        if (!cancelled) setIsPendingReachLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [alertPendingSchedule]);

  function closeScheduleModal() {
    setAlertPendingSchedule(null);
    setPendingReach(null);
  }

  async function scheduleAlert() {
    if (isScheduling) return;

    setIsScheduling(true);

    try {
      await AlertsService.createAlert(alertPendingSchedule);
      showAlert('Alert is live!', 'success');
      navigate('/alerts', { replace: true });
    } catch (error) {
      LoggingService.error('Failed to schedule alert', error);
      showAlert('Unable to schedule this alert. Please try again.', 'error');
    } finally {
      setIsScheduling(false);
    }
  }

  return (
    <Box sx={styles.page}>
      <Box sx={styles.content}>
        <AlertForm
          onBack={() => navigate('/alerts')}
          onSchedule={setAlertPendingSchedule}
        />
      </Box>
      {alertPendingSchedule && (
        <AlertScheduleModal
          alert={alertPendingSchedule}
          isOpen
          isReachLoading={isPendingReachLoading}
          onClose={closeScheduleModal}
          onConfirm={scheduleAlert}
          reach={pendingReach}
        />
      )}
    </Box>
  );
}
